import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { LogOut, Settings, User } from 'lucide-react';

export default function Navbar() {
  const { user, logout } = useAuth();

  return (
    <nav className="bg-white shadow-stickr-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <img src="/logo.svg" alt="Stickr" className="h-7 w-auto" />
            <span className="ml-3 text-lg font-semibold text-primary"></span>
          </div>
          
          <div className="flex items-center">
            <div className="relative group">
              <button className="flex items-center space-x-2 text-navy hover:text-primary transition-colors">
                <img 
                  src={user?.profile_picture || `https://ui-avatars.com/api/?name=${user?.name || 'User'}&background=e0d5eb&color=5F308C`}
                  alt={user?.name}
                  className="h-8 w-8 rounded-full border-2 border-light-purple"
                />
                <span className="font-medium">{user?.name}</span>
              </button>
              
              <div className="absolute right-0 w-48 mt-2 py-2 bg-white rounded-lg shadow-stickr-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <a href="/settings" className="flex items-center px-4 py-2 text-sm text-navy hover:bg-light-purple/20">
                  <Settings className="h-4 w-4 mr-2 text-primary" />
                  Settings
                </a>
                <button 
                  onClick={logout}
                  className="flex items-center w-full px-4 py-2 text-sm text-navy hover:bg-light-purple/20"
                >
                  <LogOut className="h-4 w-4 mr-2 text-primary" />
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}